(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-list"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('all-products-showcase')) {
    customElements.define(
      'all-products-showcase',
      class extends HTMLElement {
        connectedCallback() {
          this.addEventListener('click', this.handleThumbnailClick);
        }

        disconnectedCallback() {
          this.removeEventListener('click', this.handleThumbnailClick);
        }

        handleThumbnailClick = (event) => {
          const thumbnail = event.target.closest('.all-products-card__thumbnail[data-image-src]');
          if (!thumbnail || !this.contains(thumbnail)) return;

          const card = thumbnail.closest('.all-products-card');
          const mainImage = card?.querySelector('.all-products-card__main-image');
          if (!mainImage) return;

          mainImage.src = thumbnail.dataset.imageSrc;
          mainImage.removeAttribute('srcset');
          mainImage.alt = thumbnail.dataset.imageAlt || '';

          card.querySelectorAll('.all-products-card__thumbnail').forEach((item) => {
            const active = item === thumbnail;
            item.classList.toggle('is-active', active);
            item.setAttribute('aria-pressed', String(active));
          });
        };
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
